import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const HasilProduksi = () => {
  const [cpoId, setCpoId] = useState("");

  const formatNumber = (num) => {
    if (num === null || num === undefined || isNaN(num)) return "-";
    return Number(num).toLocaleString("id-ID");
  };

  useEffect(() => {
    window.handleKlikSumber = async (kodeSawit) => {
      try {
        Swal.fire({
          title: "Memuat Rincian...",
          allowOutsideClick: false,
          didOpen: () => Swal.showLoading()
        });

        const response = await axios.post(
          "https://c-greenproject.org:7500/rincian_sumber",
          { kode_sawit: kodeSawit }
        );

        const d = response.data;

        Swal.fire({
          title: `<div class="text-center pt-2 pb-2 border-bottom"><h5 class="fw-bold m-0" style="color: #0d9488;"><i class="fa fa-seedling me-2"></i>Rincian Sumber Sawit</h5></div>`,
          html: `
            <div class="text-start mt-3 small" style="line-height: 1.7; color: #374151;">
              <p class="mb-1"><strong>Kode Sumber:</strong> <span class="font-monospace text-success">${kodeSawit}</span></p>
              <p class="mb-1"><strong>Nama Petani:</strong> ${d.nama_petani || "-"}</p>
              <p class="mb-1"><strong>Lokasi Lahan:</strong> ${d.lahan || "-"}</p>
              <p class="mb-1"><strong>Jenis Sawit:</strong> ${d.jenis_sawit || "-"}</p>
              <p class="mb-1"><strong>Sertifikasi Lahan:</strong> <span class="badge bg-success-subtle text-success border">${d.sertifikasi_lahan || "-"}</span></p>
              <p class="mb-1"><strong>Usia Tanaman:</strong> ${d.usia ? d.usia + " Tahun" : "-"}</p>
              <p class="mb-1"><strong>Tanggal Tanam:</strong> ${d.tanggal_tanam || "-"}</p>
              <p class="mb-1"><strong>Tanggal Panen:</strong> ${d.tanggal_panen || "-"}</p>
              <p class="mb-1"><strong>Tanggal Pengiriman:</strong> ${d.tanggal_pengiriman || "-"}</p>
              <p class="mb-1"><strong>Tanggal Diterima Pabrik:</strong> ${d.tanggal_diterima_pabrik || "-"}</p>
              <p class="mb-0"><strong>Berat Sawit:</strong> <span class="font-monospace fw-bold text-dark">${d.berat_sawit ? formatNumber(d.berat_sawit) + " Kg" : "-"}</span></p>
            </div>
          `,
          confirmButtonText: "Tutup",
          confirmButtonColor: "#00d8cb",
          width: "600px",
          customClass: {
            popup: "rounded-4 shadow-lg border-0 p-4",
            confirmButton: "rounded-pill px-4 fw-bold shadow-sm",
          }
        });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Gagal",
          text: error.response?.data?.error || "Gagal memuat rincian sumber sawit.",
          confirmButtonColor: "#ff6b6b"
        });
      }
    };

    return () => {
      delete window.handleKlikSumber;
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (cpoId.trim() === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "ID CPO tidak boleh kosong!",
        confirmButtonColor: "#00d8cb",
        customClass: { confirmButton: "rounded-pill px-4 fw-bold" },
      });
      return;
    }

    try {
      const response = await axios.post(
        "https://c-greenproject.org:7500/lihat_hasil_produksi_umum",
        {
          id: cpoId.trim(),
        }
      );

      const data = response.data;

      if (response.status === 200) {
        const {
          nama_pabrik,
          hasil_cpo,
          limbah_produksi,
          sumber_produksi,
          waktu_produksi,
        } = data;

        const formatSumberProduksi = (sumber) => {
          if (!sumber || (Array.isArray(sumber) && sumber.length === 0)) 
            return `<span class="text-muted fst-italic">-</span>`;
          
          const list = Array.isArray(sumber) 
            ? sumber 
            : typeof sumber === "string" 
              ? sumber.split(",") 
              : [String(sumber)];

          return `
            <div style="display: flex; flex-direction: column; gap: 6px; margin-top: 4px;">
              ${list
                .map(
                  (item) => `
                    <div onclick="window.handleKlikSumber('${item.trim() || item}')" style="display: flex; align-items: center; justify-content: space-between; background: #e6fffa; border: 1px solid #99f0ea; padding: 6px 12px; border-radius: 8px; cursor: pointer; transition: all 0.2s;" onmouseover="this.style.backgroundColor='#ccf7f4'" onmouseout="this.style.backgroundColor='#e6fffa'">
                      <div style="display: flex; align-items: center; gap: 8px;">
                        <span style="color: #0d9488; font-size: 14px;">•</span>
                        <span style="font-family: monospace; font-size: 12px; color: #0d9488; font-weight: 600;">
                          ${item.trim()}
                        </span>
                      </div>
                      <span style="font-size: 11px; color: #0d9488; font-weight: 500;">
                        <i class="fa fa-eye me-1"></i> Klik untuk Detail
                      </span>
                    </div>
                  `
                )
                .join("")}
            </div>
          `;
        };

        Swal.fire({
          title: `<div class="text-center pt-2 pb-2 border-bottom"><h4 class="fw-bold m-0" style="color: #00d8cb; font-family: 'Poppins', sans-serif;"><i class="fa fa-industry me-2"></i>Detail Hasil Produksi CPO</h4></div>`,
          html: `
            <div class="text-start mt-3" style="font-size: 0.9rem; font-family: 'Poppins', sans-serif; color: #374151; max-height: 70vh; overflow-y: auto; padding-right: 4px;">
              
              <!-- Banner Ringkasan Hasil CPO -->
              <div class="p-3 mb-3 rounded-4 d-flex justify-content-between align-items-center" style="background: linear-gradient(135deg, #e0fbf9, #ccf7f4); border: 1px solid #99f0ea;">
                <div>
                  <span style="font-size: 11px; color: #0d9488; text-transform: uppercase; font-weight: 700; display: block; margin-bottom: 2px;">Total Hasil CPO</span>
                  <h3 class="font-monospace fw-bold m-0" style="color: #0f766e;">${formatNumber(hasil_cpo)} kg</h3>
                </div>
                <div class="bg-white text-teal p-3 rounded-circle shadow-sm" style="color: #00d8cb;">
                  <i class="fa fa-oil-can fs-4"></i>
                </div>
              </div>

              <!-- Grid Informasi Pabrik & Produksi -->
              <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 14px; background: #f8fafc; padding: 18px; border-radius: 14px; margin-bottom: 20px; border: 1px solid #e2e8f0;">
                <div>
                  <span style="font-size: 11px; color: #64748b; text-transform: uppercase; font-weight: 600; display: block; margin-bottom: 2px;">Pabrik Pengolah</span>
                  <span style="font-weight: 600; color: #1e293b;">${nama_pabrik || "-"}</span>
                </div>
                <div>
                  <span style="font-size: 11px; color: #64748b; text-transform: uppercase; font-weight: 600; display: block; margin-bottom: 2px;">Waktu Produksi</span>
                  <span style="color: #475569; font-size: 0.85rem;">${waktu_produksi || "-"}</span>
                </div>
                <div style="grid-column: span 2; border-top: 1px solid #edf2f7; padding-top: 10px;">
                  <span style="font-size: 11px; color: #64748b; text-transform: uppercase; font-weight: 600; display: block; margin-bottom: 4px;">Sumber Produksi (Klik item untuk lihat rincian petani)</span>
                  ${formatSumberProduksi(sumber_produksi)}
                </div>
              </div>

              <!-- Rincian Limbah Produksi -->
              <h6 class="fw-bold mb-2" style="font-size: 0.95rem; color: #0f766e;">Rincian Limbah Produksi</h6>
              <div class="table-responsive border rounded-3 overflow-hidden">
                <table class="table table-sm table-striped mb-0 align-middle" style="font-size: 13px;">
                  <thead class="table-light">
                    <tr>
                      <th class="py-2 px-3 fw-semibold">Jenis Limbah</th>
                      <th class="py-2 px-3 fw-semibold text-end">Jumlah Berat (kg)</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${
                      limbah_produksi && Object.keys(limbah_produksi).length > 0
                        ? Object.entries(limbah_produksi)
                            .map(([key, value]) => `
                              <tr>
                                <td class="py-2 px-3 text-capitalize fw-medium text-dark">${key.replace(/_/g, " ")}</td>
                                <td class="py-2 px-3 text-end font-monospace fw-bold text-secondary">${formatNumber(value)} kg</td>
                              </tr>
                            `)
                            .join("")
                        : `<tr><td colspan="2" class="text-center py-3 text-muted fst-italic">Tidak ada data limbah</td></tr>`
                    }
                  </tbody>
                </table>
              </div>

            </div>
          `,
          confirmButtonText: "Tutup",
          confirmButtonColor: "#00d8cb",
          background: "#ffffff",
          width: "700px",
          showCloseButton: true,
          focusConfirm: false,
          customClass: {
            popup: "rounded-4 shadow-lg border-0 p-4",
            confirmButton: "rounded-pill px-4 fw-bold shadow-sm",
          },
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.response?.data?.error || "Data hasil produksi CPO tidak ditemukan.",
        confirmButtonColor: "#ff6b6b",
        customClass: { confirmButton: "rounded-pill px-4 fw-bold" },
      });
    }
  };

  return (
    <Container
      fluid
      id="hasilProduksiSection"
      className="py-5"
      style={{
        backgroundColor: "#ffffff",
        minHeight: "380px",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Row className="justify-content-center w-100 m-0">
        <Col xs={12} className="mb-3 text-center">
          <h1
            className="fw-bold mb-1"
            style={{
              color: "#00d8cb",
              fontFamily: "Poppins, sans-serif",
              letterSpacing: "0.5px",
            }}
          >
            Hasil Produksi CPO
          </h1>
          <p className="text-muted small mb-0">
            Lacak dan verifikasi riwayat produksi minyak sawit mentah beserta rincian sumber dan limbahnya.
          </p>
        </Col>

        <Col xs={11} sm={8} md={6} lg={5}>
          <Form onSubmit={handleSubmit} className="p-4 rounded-4 shadow-sm bg-light border">
            <Form.Group className="mb-3 text-start" controlId="cpoId">
              <Form.Label
                className="fw-bold text-secondary mb-2"
                style={{ fontSize: "0.95rem", fontFamily: "Poppins, sans-serif" }}
              >
                Kode ID CPO
              </Form.Label>
              <Form.Control
                type="number"
                placeholder="Contoh: 25"
                value={cpoId}
                onChange={(e) => setCpoId(e.target.value)}
                required
                className="shadow-none rounded-3 py-2 px-3"
                style={{ borderColor: "#cbd5e1", fontSize: "0.95rem" }}
              />
              <Form.Text className="text-muted" style={{ fontSize: "11px" }}>
                Masukkan angka ID hasil produksi CPO.
              </Form.Text>
            </Form.Group>

            <div className="text-center">
              <Button
                type="submit"
                className="w-100 shadow-sm fw-bold py-2 rounded-pill text-uppercase border-0"
                style={{
                  backgroundColor: "#00d8cb",
                  color: "#ffffff",
                  letterSpacing: "0.5px",
                  transition: "all 0.2s ease",
                }}
              >
                Cek Hasil Produksi
              </Button>
            </div>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default HasilProduksi;